import { render, staticRenderFns } from "./VerifyCertify.vue?vue&type=template&id=1d7416c3&scoped=true"
import script from "./VerifyCertify.vue?vue&type=script&lang=js"
export * from "./VerifyCertify.vue?vue&type=script&lang=js"
import style0 from "./VerifyCertify.vue?vue&type=style&index=0&id=1d7416c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7416c3",
  null
  
)

export default component.exports